module.exports = __webpack_public_path__ + "img/popupbnr-2022coupon.dce05f9d.jpg";